import BarChartColumn from "./barChartColumn";

export default BarChartColumn;
